import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./navbar.css";
import "./form.css";
import { auth } from "../firebase.js";
import { signOut } from "firebase/auth";

function Navbar() {
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY >= 100) {
        document.querySelector("nav").className = "afterscroll";
      } else {
        document.querySelector("nav").className = "";
      }
    });
  });

  function toggleNavbar(e) {
    let nav = document.querySelector("nav .buttons");
    if (nav.className === "buttons inactive") nav.className = "buttons active";
    else nav.className = "buttons inactive";
  }

  //auth part
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in.
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup
  }, []);

  const navigate = useNavigate();
  function handleSignout() {
    signOut(auth).then(() => navigate("/"));
  }

  return (
    <nav>
      <span className="title">PosterGen</span>
      <span className="gap"></span>
      <div className="toggle" onClick={toggleNavbar}>
        &#9776;
      </div>

      <div className="buttons inactive">
        <Link to="/" onClick={toggleNavbar}>
          HOME
        </Link>
        <Link to="/about" onClick={toggleNavbar}>
          ABOUT
        </Link>
        <Link to="/prompt" onClick={toggleNavbar}>
          PROMPT
        </Link>
        <Link to="/pricing" onClick={toggleNavbar}>
          PRICING
        </Link>
        {!user ? (
          <Link to="/login" onClick={toggleNavbar}>
            GET STARTED
          </Link>
        ) : (
          <Link
            to="/profile"
            onClick={toggleNavbar}
            className="floating-buttons-container"
          >
            PROFILE
            <div className="floating-buttons">
              <Link to="/profile">Profile</Link>
              <Link onClick={handleSignout}>Sign out</Link>
            </div>
          </Link>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
